import { BUTTON_PRESS } from './baseEvents'

export const PROGRAM_RECOMMENDATIONS_PAGE_VIEW =
  'Page View: Program Recommendations'

export const PROGRAM_RECOMMENDATIONS_ACCEPT = `${BUTTON_PRESS} Accept`
export const PROGRAM_RECOMMENDATIONS_CONFIRM_ACCEPT = `${BUTTON_PRESS} Confirm Accept`
export const PROGRAM_RECOMMENDATIONS_REJECT = `${BUTTON_PRESS} Reject`
export const PROGRAM_RECOMMENDATIONS_CONFIRM_REJECT = `${BUTTON_PRESS} Confirm Reject`
export const PROGRAM_RECOMMENDATIONS_COMPLETE = `${BUTTON_PRESS} Mark Complete`
export const PROGRAM_RECOMMENDATIONS_ARCHIVE = `${BUTTON_PRESS} Archive`
export const PROGRAM_RECOMMENDATIONS_PUBLISH = `${BUTTON_PRESS} Publish`
